const CardHeader = ({ children }) => {
    return (
        <div className="flex flex-col md:flex-row justify-between items-center gap-2">
            {children}
        </div>
    );
};

export default CardHeader;
